import { useFormik } from 'formik';
import React, { useCallback } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as Api from '../../../api';
import { createFolder } from '../../../store/action-creators/folders';
import { TRootState } from '../../../store/reducers/RootReducer';

interface IFolderFormProps {
  onSubmit: () => void;
}

const FolderForm = (props: IFolderFormProps) => {
  const { onSubmit } = props;
  const dispatch = useDispatch<ThunkDispatch<TRootState, any, Action>>();

  const handleSubmit = useCallback((values) => {
    return dispatch(createFolder(values)).then(() => onSubmit());
  }, [dispatch, onSubmit]);

  const formik = useFormik({
    initialValues: { name: '' },
    onSubmit: (values, { setSubmitting, setErrors }) => {
      handleSubmit(values).then(() => {
        setSubmitting(false);
      }).catch(error => {
        setSubmitting(false);

        if (error instanceof Api.ValidationError) {
          const errors = error.data;
          setErrors(errors);
        }
      });
    }
  });

  return (
    <Form onSubmit={formik.handleSubmit} className="folder-create-form">
      <Form.Group controlId="folderForm">
        <Form.Label>Folder Name</Form.Label>
        <Form.Control
          name="name"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.name}
        />
        {formik.touched.name && formik.errors.name ? <Form.Text>{formik.errors.name}</Form.Text> : null}
      </Form.Group>

      <Button type="submit" disabled={formik.isSubmitting}>
        {formik.isSubmitting ? 'Creating...' : 'Create'}
      </Button>
    </Form>
  );
};

export default FolderForm;
